"use client";

import { memo, type ReactElement } from "react";
import { useTranslations } from "next-intl";
import { ResponsiveContainer } from "recharts";

interface ChartContainerProps {
  height: number;
  children: ReactElement;
  showEmpty?: boolean;
}

/**
 * Обертка для графика с ResponsiveContainer
 */
export const ChartContainer = memo(function ChartContainer({
  height,
  children,
  showEmpty = false,
}: ChartContainerProps) {
  const t = useTranslations();

  if (showEmpty) {
    return (
      <div
        className="flex items-center justify-center text-muted-foreground text-sm"
        style={{ height }}
      >
        {t("label-no-data")}
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height, minHeight: height || 200 }}>
      <ResponsiveContainer width="100%" height="100%" minHeight={height || 200}>
        {children}
      </ResponsiveContainer>
    </div>
  );
});
